interface ResultsSummaryProps {
  totalRevenue: number;
  totalProfit: number;
}

export const ResultsSummary = ({ totalRevenue, totalProfit }: ResultsSummaryProps) => {
  return (
    <div className="space-y-4 bg-primary/5 p-4 sm:p-6 rounded-lg">
      <p className="text-base sm:text-lg">
        Estimated Total Revenue:{" "}
        <span className="font-bold text-green-500">
          ${totalRevenue.toFixed(2)}
        </span>
      </p>
      <p className="text-base sm:text-lg">
        Estimated Total Profit:{" "}
        <span className="font-bold text-blue-500">
          ${totalProfit.toFixed(2)}
        </span>
      </p>
    </div>
  );
};